import { Callout } from "@clipboard-health/ui-components";
import { Box, Stack } from "@mui/material";
import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { useHistory } from "react-router-dom";

import { SHIFT_DISCOVERY_PRIORITY_PATH } from "../../ShiftDiscovery/paths";
import { useShiftModalsDataContext } from "../../ShiftDiscovery/useShiftModalsDataContext";

interface PriorityShiftsCalloutProps {
  count: number;
}

export function PriorityShiftsCallout(props: PriorityShiftsCalloutProps) {
  const { count } = props;
  const history = useHistory();
  const { baseNavigationPath } = useShiftModalsDataContext();
  const { enabled: isTiersEnabled } = useCbhFlag(CbhFeatureFlag.CONFIG_TIERS, {
    defaultValue: { enabled: false },
  });
  if (count <= 0 || isTiersEnabled) {
    return null;
  }

  return (
    <Callout
      aria-label="View Priority Shifts"
      title={
        <Stack direction="row" alignItems="center" gap={2} component="span">
          <Box component="span">Priority</Box>
          <Box component="span">{count}</Box>
        </Stack>
      }
      iconType="priority"
      sx={(theme) => ({
        backgroundColor: theme.palette.shift?.priority.background,
        color: theme.palette.shift?.priority.text,
      })}
      onClick={() => {
        logEvent(APP_V2_USER_EVENTS.OPEN_SHIFTS_CALLOUT_VIEWED, { type: "priorityShifts", count });
        history.push(`${baseNavigationPath}/${SHIFT_DISCOVERY_PRIORITY_PATH}`);
      }}
    />
  );
}
